import { render, staticRenderFns } from "./SketchOutlinedIcon.vue?vue&type=template&id=0711640b&scoped=true"
import script from "./SketchOutlinedIcon.vue?vue&type=script&lang=js"
export * from "./SketchOutlinedIcon.vue?vue&type=script&lang=js"
import style0 from "./SketchOutlinedIcon.vue?vue&type=style&index=0&id=0711640b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0711640b",
  null
  
)

export default component.exports